export const leadsIt: Record<string, string> = {
  'leads.errors.createFailed': 'Impossibile creare il contatto',
  'leads.created': 'Creato',
  'leads.boardSettings': 'Impostazioni Bacheca',
  'leads.boardSettingsUpdated': 'Impostazioni Bacheca Aggiornate',
  'leads.boardSettingsDescription': 'Le preferenze di visibilità delle colonne sono state salvate.',
  'leads.columnVisibility': 'Visibilità Colonne',
  'leads.visibleOf': '{visible} di {total} visibili',
  'leads.columnVisibilityHint': 'Scegli quali colonne di fase visualizzare nella tua bacheca Kanban. Le fasi nascoste rimangono accessibili nella ricerca e nei rapporti.',
  'leads.applyChanges': 'Applica Modifiche',
  'leads.resetToDefaults': 'Ripristina Impostazioni Predefinite',
  'leads.hiddenByDefault': 'Nascosto per impostazione predefinita',
  'leads.atLeastOneColumn': 'Almeno una colonna deve essere visibile sulla bacheca.',
  'leads.title': 'Contatti',
  'leads.newLead': 'Nuovo Contatto',
  'leads.createNewLead': 'Crea Nuovo Contatto',
  'leads.success.created': 'Contatto creato con successo',
  'leads.success.stageUpdated': 'Fase contatto aggiornata con successo',
  'leads.createTitle': 'Crea Nuovo Lead',
  'leads.create.cancel': 'Annulla',
  'leads.create.submit': 'Crea Contatto',
  'leads.create.submitting': 'Creazione Contatto...',
  'leads.create.quickCapture': "Acquisizione Rapida: Solo il nome O l'email sono obbligatori. Tutte le altre informazioni sono facoltative e possono essere aggiunte in seguito.",
  'leads.create.contactInfo': 'Informazioni di Contatto',
  'leads.create.firstName': 'Nome',
  'leads.create.lastName': 'Cognome',
  'leads.create.email': 'Email',
  'leads.create.phone': 'Telefono',
  'leads.create.details': 'Dettagli Contatto',
  'leads.create.source': 'Fonte del Contatto',
  'leads.create.selectSource': 'Seleziona fonte',
  'leads.create.budgetMin': 'Budget Min (€)',
  'leads.create.budgetMax': 'Budget Max (€)',
  'leads.create.weddingDate': 'Data Matrimonio',
  'leads.create.notes': 'Note',
  'leads.create.placeholder.firstName': 'Nome',
  'leads.create.placeholder.lastName': 'Cognome',
  'leads.create.placeholder.email': 'email@esempio.com',
  'leads.create.placeholder.phone': 'Numero di telefono',
  'leads.create.placeholder.budgetMin': 'Budget minimo',
  'leads.create.placeholder.budgetMax': 'Budget massimo',
  'leads.create.placeholder.notes': 'Note aggiuntive...',
  'leads.create.orgNotFound': 'Organizzazione non trovata',
  'leads.create.stagesError': 'Impossibile caricare le fasi del contatto',
  'leads.create.validation.nameOrEmail': "È richiesto almeno il nome o l'email",
  'leads.create.validation.emailInvalid': 'Formato email non valido',
  'leads.create.successDescription': 'Contatto creato con successo! Tutte le informazioni sono state acquisite.',
  'leads.errors.apiFailed': 'Errore API: {message}',
  'leads.errors.loadFailed': 'Impossibile caricare i contatti',
  'leads.errors.loadStagesFailed': 'Impossibile caricare le fasi dei contatti',
  'leads.errors.updateStageFailed': 'Impossibile aggiornare la fase del contatto',
  'leads.errors.deleteFailed': 'Impossibile eliminare il contatto',
  'leads.errors.convertFailed': 'Impossibile convertire il contatto in cliente',
  'leads.errors.noCustomerFound': 'Nessun Cliente Trovato',
  'leads.errors.noCustomerDescription': 'Nessun record cliente trovato per questo contatto. Convertire prima il contatto in cliente.',
  'leads.errors.contactUpdateFailed': 'Impossibile aggiornare le informazioni di contatto',
  'leads.errors.eventUpdateFailed': "Impossibile aggiornare i dettagli dell'evento",
  'leads.errors.dressPrefsUpdateFailed': 'Impossibile aggiornare le preferenze abito',
  'leads.errors.decisionUpdateFailed': 'Impossibile aggiornare le informazioni decisionali',
  'leads.success.deleted': 'Contatto eliminato con successo',
  'leads.success.converted': 'Contatto convertito in cliente con successo e spostato alla fase finale.',
  'leads.success.contactUpdated': 'Informazioni di contatto aggiornate con successo',
  'leads.success.eventUpdated': 'Dettagli evento aggiornati con successo',
  'leads.success.dressPrefsUpdated': 'Preferenze abito aggiornate con successo',
  'leads.success.decisionUpdated': 'Informazioni decisionali aggiornate con successo',
  'leads.searchPlaceholder': 'Cerca contatti...',
  'leads.searchPlaceholderFull': 'Cerca per nome, email o telefono...',
  'leads.allStages': 'Tutte le Fasi',
  'leads.kanbanBoard': 'Bacheca Kanban',
  'leads.tableView': 'Vista Tabella',
  'leads.showMore': 'Mostra altri {count}',
  'leads.showLess': 'Mostra meno',
  'leads.table.name': 'Nome',
  'leads.table.contact': 'Contatto',
  'leads.table.stage': 'Fase',
  'leads.table.source': 'Fonte',
  'leads.table.budget': 'Budget',
  'leads.table.weddingDate': 'Data Matrimonio',
  'leads.table.created': 'Creato',
  'leads.assignedTo': 'Assegnato a:',
  'leads.actions.viewCustomer': 'Vedi Cliente',
  'leads.actions.editLead': 'Modifica Contatto',
  'leads.actions.scheduleAppointment': 'Pianifica Appuntamento',
  'leads.actions.converting': 'Conversione...',
  'leads.actions.convertToCustomer': 'Converti in Cliente',
  'leads.actions.deleteLead': 'Elimina Contatto',
  'leads.actions.editContact': 'Modifica Contatto',
  'leads.actions.editEventDetails': 'Modifica Dettagli Evento',
  'leads.actions.editDressPrefs': 'Modifica Preferenze Abito',
  'leads.actions.editDecisionMaking': 'Modifica Info Decisionali',
  'leads.editTitle': 'Modifica Contatto',
  'leads.bundles.basicContact': 'Informazioni di Contatto Base',
  'leads.bundles.eventDetails': 'Dettagli Evento',
  'leads.bundles.dressPreferences': 'Preferenze Abito',
  'leads.bundles.decisionMaking': 'Informazioni Decisionali',
  'leads.bundles.personalization': 'Capsule di Personalizzazione',
  'leads.bundles.leadManagement': 'Gestione Contatto',
  'leads.bundles.crossSell': 'Opportunità Cross-sell',
  'leads.bundles.comments': 'Commenti',
  'leads.bundles.appointmentHistory': 'Cronologia Appuntamenti',
  'leads.bundles.leadActions': 'Azioni Contatto',
  'leads.appointmentHistoryTransferNote': 'La cronologia degli appuntamenti verrà trasferita automaticamente quando il contatto viene convertito in cliente.',
  'leads.convertNote': 'Quando converti questo contatto in cliente, tutte le informazioni di contatto verranno trasferite automaticamente.',
  'leads.deleteTitle': 'Elimina Contatto',
  'leads.deleteConfirmation': 'Sei sicuro di voler eliminare questo contatto per {name}? Questa azione non può essere annullata.',

  // History
  'history.title': 'Storico',
  'history.from_to': 'Da {from} a {to}',
  'history.no_data': 'Nessuno storico disponibile',
  'history.no_data_description': 'I cambiamenti di fase appariranno qui una volta che il contatto passa attraverso diverse fasi.',
  'history.transition': 'Transizione di fase',
  'history.load_more': 'Carica altro',
  'history.fetch_error': 'Impossibile caricare lo storico',

  // Dettaglio: Contatto Base
  'leads.detail.basicContact.title': 'Contatto Base',
  'leads.detail.basicContact.noName': 'Nessun nome fornito',

  // Dettaglio: Form Contatto
  'leads.detail.contactForm.customerTitle': 'Informazioni Contatto Cliente',
  'leads.detail.contactForm.leadTitle': 'Informazioni Contatto Lead',
  'leads.detail.contactForm.firstName': 'Nome',
  'leads.detail.contactForm.lastName': 'Cognome',
  'leads.detail.contactForm.email': 'Email',
  'leads.detail.contactForm.phone': 'Telefono',
  'leads.detail.contactForm.preferredComms': 'Comunicazione Preferita',
  'leads.detail.contactForm.firstNamePlaceholder': 'Inserisci nome',
  'leads.detail.contactForm.lastNamePlaceholder': 'Inserisci cognome',
  'leads.detail.contactForm.emailPlaceholder': 'Inserisci indirizzo email',
  'leads.detail.contactForm.phonePlaceholder': 'Inserisci numero di telefono',
  'leads.detail.contactForm.commsPlaceholder': 'Seleziona metodo di comunicazione preferito',
  'leads.detail.contactForm.save': 'Salva Informazioni Contatto',

  // Dettaglio: Dettagli Evento
  'leads.detail.eventDetails.title': 'Dettagli Evento',
  'leads.detail.eventDetails.noData': 'Nessun dettaglio evento fornito',
  'leads.detail.eventDetails.weddingDate': 'Data Matrimonio:',
  'leads.detail.eventDetails.location': 'Luogo:',
  'leads.detail.eventDetails.ceremony': 'Cerimonia:',
  'leads.detail.eventDetails.reception': 'Ricevimento:',

  // Dettaglio: Form Evento
  'leads.detail.eventForm.title': 'Dettagli Evento',
  'leads.detail.eventForm.weddingDate': 'Data Matrimonio',
  'leads.detail.eventForm.pickDate': 'Seleziona una data',
  'leads.detail.eventForm.eventLocation': 'Luogo Evento',
  'leads.detail.eventForm.eventLocationPlaceholder': 'Inserisci luogo/città evento',
  'leads.detail.eventForm.ceremonyVenue': 'Luogo Cerimonia',
  'leads.detail.eventForm.ceremonyVenuePlaceholder': 'Inserisci luogo cerimonia',
  'leads.detail.eventForm.receptionVenue': 'Luogo Ricevimento',
  'leads.detail.eventForm.receptionVenuePlaceholder': 'Inserisci luogo ricevimento',
  'leads.detail.eventForm.save': 'Salva Dettagli Evento',

  // Dettaglio: Decisioni
  'leads.detail.decision.title': 'Processo Decisionale',
  'leads.detail.decision.noData': 'Nessuna informazione decisionale fornita',
  'leads.detail.decision.participants': 'Partecipanti alla Decisione:',
  'leads.detail.decision.timeline': 'Tempistiche:',
  'leads.detail.decision.consideringAlso': 'Stanno anche valutando:',
  'leads.detail.decision.timeline.urgent': 'Urgente (< 1 mese)',
  'leads.detail.decision.timeline.short': 'Breve termine (1-3 mesi)',
  'leads.detail.decision.timeline.medium': 'Medio termine (3-6 mesi)',
  'leads.detail.decision.timeline.long': 'Lungo termine (6+ mesi)',
  'leads.detail.decision.timeline.flexible': 'Tempistiche flessibili',

  // Dettaglio: Form Decisioni
  'leads.detail.decisionForm.title': 'Informazioni Processo Decisionale',
  'leads.detail.decisionForm.buyingTimeline': 'Tempistiche di Acquisto',
  'leads.detail.decisionForm.selectTimeline': 'Seleziona tempistiche di acquisto',
  'leads.detail.decisionForm.participants': 'Partecipanti alla Decisione',
  'leads.detail.decisionForm.addParticipant': 'Aggiungi un partecipante',
  'leads.detail.decisionForm.customParticipant': 'O inserisci partecipante personalizzato',
  'leads.detail.decisionForm.competitors': 'Concorrenti / Stanno Anche Valutando',
  'leads.detail.decisionForm.addCompetitor': 'Aggiungi un concorrente',
  'leads.detail.decisionForm.customCompetitor': 'O inserisci concorrente personalizzato',
  'leads.detail.decisionForm.save': 'Salva Info Decisione',

  // Dettaglio: Preferenze Abito
  'leads.detail.dress.title': 'Preferenze Abito',
  'leads.detail.dress.noData': 'Nessuna preferenza abito fornita',
  'leads.detail.dress.styles': 'Stili Preferiti:',
  'leads.detail.dress.brands': 'Marche Preferite:',
  'leads.detail.dress.size': 'Taglia Abito:',
  'leads.detail.dress.inspiration': 'Immagini Ispirazione:',
  'leads.detail.dress.moreImages': '+{count} altre immagini',

  // Dettaglio: Form Preferenze Abito
  'leads.detail.dressForm.title': 'Preferenze Abito',
  'leads.detail.dressForm.budgetRange': 'Fascia Budget (€)',
  'leads.detail.dressForm.minimum': 'Minimo',
  'leads.detail.dressForm.maximum': 'Massimo',
  'leads.detail.dressForm.size': 'Taglia Abito',
  'leads.detail.dressForm.selectSize': 'Seleziona taglia abito',
  'leads.detail.dressForm.sizePrefix': 'Taglia',
  'leads.detail.dressForm.styles': 'Stili Preferiti',
  'leads.detail.dressForm.addStyle': 'Aggiungi una preferenza stile',
  'leads.detail.dressForm.brands': 'Marche Preferite',
  'leads.detail.dressForm.addBrand': 'Aggiungi una preferenza marca',
  'leads.detail.dressForm.inspirationImages': 'Immagini Ispirazione (fino a 5 URL)',
  'leads.detail.dressForm.imageUrlPlaceholder': 'Inserisci URL immagine (Pinterest, Instagram, ecc.)',
  'leads.detail.dressForm.save': 'Salva Preferenze Abito',

  // Dettaglio: Personalizzazione
  'leads.detail.personalization.title': 'Note di Personalizzazione',
  'leads.detail.personalization.noNotes': 'Nessuna nota di personalizzazione aggiunta. Clicca modifica per aggiungere richieste speciali, esperienze preferite o note emotive.',
  'leads.detail.personalization.editTitle': 'Modifica Note Personalizzazione',
  'leads.detail.personalization.label': 'Richieste Speciali, Esperienza Preferita e Note Emotive',
  'leads.detail.personalization.placeholder': 'Inserisci richieste speciali, dettagli esperienza preferita, note emotive o altre informazioni personalizzate su questa sposa...',
  'leads.detail.personalization.success': 'Note di personalizzazione aggiornate con successo',
  'leads.detail.personalization.error': 'Impossibile aggiornare le note di personalizzazione',

  // Dettaglio: Cross-sell
  'leads.detail.crossSell.title': 'Opportunità Cross-sell',
  'leads.detail.crossSell.bridesmaids': 'Abiti Damigelle',
  'leads.detail.crossSell.bridesmaidsDesc': 'Interesse negli abiti per damigelle',
  'leads.detail.crossSell.accessories': 'Accessori',
  'leads.detail.crossSell.accessoriesDesc': 'Interesse in veli, gioielli e accessori',
  'leads.detail.crossSell.alterations': 'Modifiche',
  'leads.detail.crossSell.alterationsDesc': 'Interesse in modifiche professionali abito',
  'leads.detail.crossSell.summary': '{count} di 3 opportunità cross-sell identificate',
  'leads.detail.crossSell.success': 'Interesse cross-sell aggiornato con successo',
  'leads.detail.crossSell.error': 'Impossibile aggiornare interesse cross-sell',

  // Dettaglio: Gestione Lead
  'leads.detail.management.title': 'Gestione Contatto',
  'leads.detail.management.currentStage': 'Fase Corrente',
  'leads.detail.management.selectStage': 'Seleziona fase',
  'leads.detail.management.followUpTimeline': 'Cronologia Follow-up',
  'leads.detail.management.addNote': 'Aggiungi Nota',
  'leads.detail.management.notePlaceholder': 'Aggiungi una nota di follow-up...',
  'leads.detail.management.noNotes': 'Nessuna nota di follow-up. Aggiungi una nota per tracciare il progresso.',
  'leads.detail.management.reminder': 'Promemoria',
  'leads.detail.management.stageSuccess': 'Fase contatto aggiornata con successo',
  'leads.detail.management.stageError': 'Impossibile aggiornare la fase del contatto',
  'leads.detail.management.noteSuccess': 'Nota di follow-up aggiunta con successo',
  'leads.detail.management.noteError': 'Impossibile aggiungere la nota di follow-up',

  // Dettaglio: Pipeline
  'leads.detail.pipeline.title': 'Informazioni Pipeline Lead',
  'leads.detail.pipeline.source': 'Fonte Lead',
  'leads.detail.pipeline.sourcePlaceholder': 'es., Google Ads, Referral, Di persona',
  'leads.detail.pipeline.campaignId': 'ID Campagna',
  'leads.detail.pipeline.campaignIdPlaceholder': 'ID campagna primo contatto',
  'leads.detail.pipeline.healthScore': 'Punteggio Salute (1-5)',
  'leads.detail.pipeline.healthPlaceholder': 'Seleziona punteggio salute',
  'leads.detail.pipeline.health1': '1 - Freddo',
  'leads.detail.pipeline.health2': '2 - Fresco',
  'leads.detail.pipeline.health3': '3 - Tiepido',
  'leads.detail.pipeline.health4': '4 - Caldo',
  'leads.detail.pipeline.health5': '5 - Molto Caldo',
  'leads.detail.pipeline.nextContactDate': 'Data Prossimo Contatto',
  'leads.detail.pipeline.firstVisitDate': 'Data Prima Visita',
  'leads.detail.pipeline.pickDate': 'Seleziona una data',
  'leads.detail.pipeline.budgetMin': 'Budget Min (€)',
  'leads.detail.pipeline.budgetMinPlaceholder': 'Budget minimo',
  'leads.detail.pipeline.budgetMax': 'Budget Max (€)',
  'leads.detail.pipeline.budgetMaxPlaceholder': 'Budget massimo',
  'leads.detail.pipeline.lostReason': 'Motivo Perdita (se applicabile)',
  'leads.detail.pipeline.lostReasonPlaceholder': 'Motivo se il contatto è stato perso',
  'leads.detail.pipeline.notes': 'Note Pipeline',
  'leads.detail.pipeline.notesPlaceholder': 'Note interne sullo stato pipeline di questo contatto',
  'leads.detail.pipeline.save': 'Salva Informazioni Pipeline',

  // Dettaglio: Commenti
  'leads.detail.comments.title': 'Aggiungi Commento',
  'leads.detail.comments.placeholder': 'Aggiungi un commento...',
  'leads.detail.comments.adding': 'Aggiunta...',
  'leads.detail.comments.addButton': 'Aggiungi Commento',
  'leads.detail.comments.noComments': 'Nessun commento ancora',
  'leads.detail.comments.beFirst': 'Sii il primo ad aggiungere un commento su questo contatto',
  'leads.detail.comments.unknownUser': 'Utente Sconosciuto',
  'leads.detail.comments.loginRequired': 'Devi essere autenticato per visualizzare i commenti',
  'leads.detail.comments.loadError': 'Impossibile caricare i commenti',
  'leads.detail.comments.loginToAdd': 'Devi essere autenticato per aggiungere commenti',
  'leads.detail.comments.addSuccess': 'Commento aggiunto con successo',
  'leads.detail.comments.addError': 'Impossibile aggiungere il commento',

  // Dettaglio: Cronologia Appuntamenti
  'leads.detail.appointmentHistory.title': 'Cronologia Appuntamenti',
  'leads.detail.appointmentHistory.upcoming': '{count} prossimi',
  'leads.detail.appointmentHistory.past': '{count} passati',
  'leads.detail.appointmentHistory.noAppointments': 'Nessun appuntamento pianificato',
  'leads.detail.appointmentHistory.notes': 'Note: ',

  // Dettaglio: Campi Personalizzati
  'leads.detail.customFields.title': 'Campi Personalizzati',
  'leads.detail.customFields.noFields': 'Nessun campo personalizzato disponibile',
  'leads.detail.customFields.noFieldsDescription': 'I campi personalizzati dai moduli appariranno qui',
  'leads.detail.customFields.noFieldsDesc': 'I campi personalizzati dai moduli appariranno qui',
  'leads.detail.customFields.edit': 'Modifica',
  'leads.detail.customFields.searchPlaceholder': 'Cerca campi personalizzati...',
  'leads.detail.customFields.all': 'Tutti',
  'leads.detail.customFields.showEmpty': 'Mostra campi vuoti',
  'leads.detail.customFields.hideEmpty': 'Nascondi campi vuoti',
  'leads.detail.customFields.of': 'di',
  'leads.detail.customFields.fields': 'campi',
  'leads.detail.customFields.fieldCount': '{filtered} di {total} campi',
  'leads.detail.customFields.noMatch': 'Nessun campo corrisponde ai criteri di ricerca',
  'leads.detail.customFields.clearFilters': 'Cancella filtri',
  'leads.detail.customFields.saveChanges': 'Salva Modifiche',

  // Dettaglio: Navigazione Sezioni
  'leads.detail.sections': 'Sezioni',
  'leads.detail.page.loadLeadError': 'Impossibile caricare le informazioni del contatto',
  'leads.detail.page.unsavedConfirm': 'Hai modifiche non salvate. Sei sicuro di voler uscire?',
  'leads.detail.page.unknownLead': 'Contatto sconosciuto',
  'leads.detail.page.notFound': 'Contatto non trovato',
  'leads.detail.page.backToLeads': 'Torna ai contatti',
  'leads.detail.page.back': 'Indietro',
  'leads.detail.page.leadMeta': 'ID contatto: {id} • Creato {createdAt}',
  'leads.detail.page.unsaved': '{count} non salvati',
  'leads.detail.page.quickActions': 'Azioni rapide',
  'leads.detail.page.call': 'Chiama',
  'leads.detail.page.email': 'Email',
  'leads.detail.page.book': 'Prenota',
  'leads.detail.page.generalNotes': 'Note generali',
  'leads.detail.page.generalNotesPlaceholder': 'Inserisci note generali...',
  'leads.detail.page.notesUpdated': 'Note aggiornate con successo',
  'leads.detail.page.save': 'Salva',
  'leads.detail.page.noNotesAvailable': 'Nessuna nota disponibile',
  'leads.detail.customFields.success': 'Campi personalizzati aggiornati con successo',
  'leads.detail.page.noPhoneTitle': 'Nessun numero di telefono',
  'leads.detail.page.noPhoneDescription': 'Nessun numero di telefono disponibile per questo cliente.',
  'leads.detail.page.messageTitle': 'Funzione messaggi',
  'leads.detail.page.messageComingSoon': 'Funzione messaggi in arrivo!',
  'leads.detail.page.changesSaved': 'Modifiche salvate con successo.',
  'leads.detail.page.saveChangesError': 'Impossibile salvare le modifiche.',
  'leads.detail.page.loadingLeadDetails': 'Caricamento dettagli contatto...',
  'leads.detail.page.notFoundDescription': 'Il contatto che stai cercando non esiste o non hai i permessi per visualizzarlo.',
  'leads.detail.page.message': 'Messaggio',
  'leads.detail.page.appointment': 'Appuntamento',
  'leads.detail.page.name': 'Nome',
  'leads.detail.page.notSet': 'Non impostato',
  'leads.detail.page.notSpecified': 'Non specificato',
  'leads.detail.page.notRated': 'Non valutato',
  'leads.detail.page.notScheduled': 'Non pianificato',
  'leads.detail.page.budgetRange': 'Fascia budget',
  'leads.detail.page.unlimited': 'illimitato',

  // Kanban Card
  'leads.followUp': 'Follow-up',
  'leads.wedding': 'Matrimonio:',
  'leads.budget': 'Budget:',
};
